<div class="contains-button">
  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
  </div>
  <ng-container *ngIf="!isViewAll">
    <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      <!-- Cấu hình thông số cơ bản của button-->
      <li
        nz-submenu
        nzTitle="{{'hien_thi'| translate}}"
        [(nzOpen)]="openMap.menu1"
        (nzOpenChange)="openHandler('menu1')"
      >
        <div class="button-size">
          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <div *ngIf="device != 'mobile_portrait'" class="item-basic">
            <div class="text-basic" style="display: flex; align-items: center">
              Ẩn hiển thị ở mobile
            </div>
            <nz-switch
              [(ngModel)]="objectChoosing.mobile_portrait_hidden"
              (ngModelChange)="updateHidden({ mobile_portrait_hidden: $event })"
            ></nz-switch>
          </div>
          <div *ngIf="device != 'desktop'" class="item-basic">
            <div class="text-basic" style="display: flex; align-items: center">
              Ẩn hiển thị ở desktop
            </div>
            <nz-switch
              [(ngModel)]="objectChoosing.desktop_hidden"
              (ngModelChange)="updateHidden({ desktop_hidden: $event })"
            ></nz-switch>
          </div>
          <div *ngIf="device != 'tablet_landscape'" class="item-basic">
            <div class="text-basic" style="display: flex; align-items: center">
              Ẩn hiển thị ở tablet landscape
            </div>
            <nz-switch
              [(ngModel)]="objectChoosing.tablet_landscape_hidden"
              (ngModelChange)="
                updateHidden({ tablet_landscape_hidden: $event })
              "
            ></nz-switch>
          </div>
          <div *ngIf="device != 'tablet_portrait'" class="item-basic">
            <div class="text-basic" style="display: flex; align-items: center">
              Ẩn hiển thị ở tablet portrait
            </div>
            <nz-switch
              [(ngModel)]="objectChoosing.tablet_portrait_hidden"
              (ngModelChange)="updateHidden({ tablet_portrait_hidden: $event })"
            ></nz-switch>
          </div>
          <div *ngIf="device != 'mobile_landscape'" class="item-basic">
            <div class="text-basic" style="display: flex; align-items: center">
              Ẩn hiển thị ở mobile landscape
            </div>
            <nz-switch
              [(ngModel)]="objectChoosing.mobile_landscape_hidden"
              (ngModelChange)="
                updateHidden({ mobile_landscape_hidden: $event })
              "
            ></nz-switch>
          </div>
        </div>
      </li>
      <!-- Cấu hình format font name của button -->
      <li
        nz-submenu
        nzTitle="{{'dinh_dang_ten_nut' | translate}}"
        [(nzOpen)]="openMap.menu2"
        (nzOpenChange)="openHandler('menu2')"
      >
        <div class="container-font">
          <!-- chọn ngôn ngữ đa ngôn ngữ -->
          <div class="mb-3">
            
          </div>
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>Nội dung</mat-label>
              <textarea
                matInput
                [ngModel]="staticdata['content_' + functionService.selectedLanguageCode] | vhLanguage : 'content' : objectChoosing.component" 
                (ngModelChange)="staticdata['content_' + functionService.selectedLanguageCode] = $event"  
                (blur)="updateStaticData()"
              ></textarea>
            </mat-form-field>
          </div>
          <div class="config-font-size">
            <div class="field-row-font" style="width: 65%">
              <mat-form-field style="width: 100%">
                <mat-label>Font</mat-label>
                <mat-select
                  [(ngModel)]="class['button__content']['font-family']"
                  (ngModelChange)="updateClass()"
                  [(value)]="class['button__content']['font-family']"
                >
                  <mat-option *ngFor="let font of fonts" [value]="font.value">{{
                    font.name
                  }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="field-row-size" style="width: 35%">
              <mat-form-field style="width: 100%">
                <mat-label>{{'kich_thuoc' | translate}}</mat-label>
                <input
                  matInput
                  type="number"
                  [ngModel]="class['button__content']['font-size'] | vhnumber"
                  (ngModelChange)="
                    class['button__content']['font-size'] = $event + 'px'
                  "
                />
              </mat-form-field>
            </div>
          </div>
          <div class="config-font">
            <p class="title-font">{{'kieu_chu' | translate}}</p>
            <div class="field-row">
              <button
                class="font-text-btn font-text-btn-bold"
                title="bold"
                nz-button
                [nzType]="
                  class['button__content']['font-weight'] == 'bold'
                    ? 'primary'
                    : 'default'
                "
                (click)="
                  class['button__content']['font-weight'] =
                    class['button__content']['font-weight'] == 'bold'
                      ? '500'
                      : 'bold';
                  updateClass()
                "
              >
                <span style="font-weight: 600">B</span>
              </button>
              <button
                class="font-text-btn font-text-btn-italic"
                title="Italic"
                nz-button
                [nzType]="
                  class['button__content']['font-style'] == 'italic'
                    ? 'primary'
                    : 'default'
                "
                (click)="
                  class['button__content']['font-style'] =
                    class['button__content']['font-style'] == 'normal'
                      ? 'italic'
                      : 'normal';
                  updateClass()
                "
              >
                <i
                  nz-icon
                  nzType="italic"
                  nzTheme="outline"
                  style="font-size: 14px"
                ></i>
              </button>
              <button
                class="font-text-btn font-text-btn-underline"
                title="Underline"
                nz-button
                [nzType]="
                  class['button__content']['text-decoration'] == 'underline'
                    ? 'primary'
                    : 'default'
                "
                (click)="
                  class['button__content']['text-decoration'] =
                    class['button__content']['text-decoration'] == 'none'
                      ? 'underline'
                      : 'none';
                  updateClass()
                "
              >
                <i
                  nz-icon
                  nzType="underline"
                  nzTheme="outline"
                  style="font-size: 14px"
                ></i>
              </button>
              <button
                class="font-text-btn font-text-btn-uppercase"
                title="Uppercase"
                nz-button
                [nzType]="
                  class['button__content']['text-transform'] == 'uppercase'
                    ? 'primary'
                    : 'default'
                "
                (click)="
                  class['button__content']['text-transform'] =
                    class['button__content']['text-transform'] == 'none'
                      ? 'uppercase'
                      : 'none';
                  updateClass()
                "
              >
                <span>AB</span>
              </button>
              <input
                id="color" type="button" 
                [cpOKButton]="true" [(colorPicker)]="class['button__content'].color"
                style="
                  min-width: 30px !important;
                  min-height: 30px !important;
                  outline: none;
                "
                [style.background]="class['button__content'].color"
                (colorPickerClose)="updateObject()"
                [cpWidth]="'230px'"
                [cpPositionRelativeToArrow]="true"
              />
            </div>
          </div>
          <div class="font-adjusting">
            <div class="row-spacing">
              <span class="title">Giãn cách chữ</span>
              <nz-input-number
                [nzMin]="0"
                [nzMax]="30"
                [ngStyle]="{ width: '40%' }"
                [ngModel]="
                  class['button__content']['letter-spacing'] | vhnumber
                "
                (nzBlur)="updateClass()"
                (ngModelChange)="
                  class['button__content']['letter-spacing'] = $event + 'px'
                "
              ></nz-input-number>
            </div>
            <nz-slider
              [nzMin]="0"
              [nzMax]="30"
              [ngModel]="class['button__content']['letter-spacing'] | vhnumber"
              (nzOnAfterChange)="updateClass()"
              (ngModelChange)="
                class['button__content']['letter-spacing'] = $event + 'px'
              "
            ></nz-slider>
          </div>
          <div class="font-adjusting">
            <div class="row-spacing">
              <span class="title"> Khoảng cách dòng</span>
              <nz-input-number
                [nzMin]="0"
                [nzMax]="3"
                [ngStyle]="{ width: '40%' }"
                [nzStep]="0.1"
                [(ngModel)]="class['button__content']['line-height']"
                (nzBlur)="updateClass()"
              ></nz-input-number>
            </div>
            <nz-slider
              [nzMin]="0"
              [nzMax]="3"
              [nzStep]="0.1"
              [(ngModel)]="class['button__content']['line-height']"
              (nzOnAfterChange)="updateClass()"
            ></nz-slider>
          </div>

          <label class="px-1">Giãn cách</label>
          <div class="padding">
            <div class="d-flex">
              <img
                src="assets/root/images/system/icons/padding-top.svg"
                alt="1"
                width="30px"
              />
              <nz-input-number
                [nzMin]="0"
                [nzMax]="200"
                style="max-width: 50%"
                [ngModel]="class['button']['padding-top'] | vhnumber"
                (nzBlur)="updateClass()"
                (ngModelChange)="
                  class['button']['padding-top'] = $event + 'px';
                  class['button']['padding-bottom'] = $event + 'px'
                "
              ></nz-input-number>
            </div>
            <div class="d-flex">
              <img
                src="assets/root/images/system/icons/padding-right-left.svg"
                alt="1"
                width="30px"
              />
              <nz-input-number
                [nzMin]="0"
                [nzMax]="200"
                style="max-width: 50%"
                [ngModel]="class['button']['padding-left'] | vhnumber"
                (nzBlur)="updateClass()"
                (ngModelChange)="
                  class['button']['padding-right'] = $event + 'px';
                  class['button']['padding-left'] = $event + 'px'
                "
              ></nz-input-number>
            </div>
          </div>
        </div>
      </li>
      <!-- Cấu hình màu nền của button -->
      <li
        nz-submenu
        nzTitle="{{'mau_sac' | translate}}"
        [(nzOpen)]="openMap.menu3"
        (nzOpenChange)="openHandler('menu3')"
      >
        <div class="container-color">
          <button
            id="btn-color"
            *ngFor="let background of backgroundColor; let i = index"
            [ngStyle]="{ 'background-color': background.bgColor }"
            (click)="chooseBg(background, $event)"
            nz-tooltip
            [disabled]="config['background-color'].gradient_check"
          ></button>
        </div>
        <div class="color-pick">
          <span class="title w-50">Chọn màu</span>
          <input
            class="input-color w-50"
            type="button"
            [cpOKButton]="true" [(colorPicker)]="class['button']['background-color']"
            [style.background]="class['button']['background-color']"
            (colorPickerClose)="updateObject()"
            [cpWidth]="'230px'"
            [cpPositionRelativeToArrow]="true"
          />
        </div>
        <div
          class="mr-2 mb-4 mt-4 view-more"
          style="
            display: flex;
            align-items: center;
            justify-content: flex-end;
            gap: 7px;
          "
        >
          <p
            class="discover_text"
            (click)="openViewAll(styles_field[3])"
            style="cursor: pointer; text-align: left; margin: 0"
          >
            Mở rộng &#8594;
          </p>
        </div>
      </li>
      <!-- Cấu hình đổ bóng -->
      <li
        nz-submenu
        nzTitle="{{'do_bong' | translate}}"
        [(nzOpen)]="openMap.menu4"
        (nzOpenChange)="openHandler('menu4')"
      >
        <div class="item-shadow">
          <p class="m-0 title">Áp dụng</p>
          <nz-switch
            [(ngModel)]="config['box-shadow']['shadow_check']"
            (ngModelChange)="onChangeShadow(); updateObject()"
          ></nz-switch>
        </div>
        <div class="shadow-direction">
          <div class="dir-x">
            <div class="row-x">
              <span>{{'truc_x' | translate}}</span>
              <nz-input-number
                [nzMin]="-30"
                [nzMax]="30"
                [ngStyle]="{ marginLeft: '16px', width: '40%' }"
                [(ngModel)]="config['box-shadow']['offset_x']"
                (ngModelChange)="onChangeShadow()"
                (nzOnAfterChange)="updateObject()"
                [disabled]="!config['box-shadow']['shadow_check']"
              ></nz-input-number>
            </div>
            <nz-row>
              <nz-col nzSpan="24">
                <nz-slider
                  [nzMin]="-30"
                  [nzMax]="30"
                  [(ngModel)]="config['box-shadow']['offset_x']"
                  (ngModelChange)="onChangeShadow()"
                  (nzOnAfterChange)="updateObject()"
                  [nzDisabled]="!config['box-shadow']['shadow_check']"
                ></nz-slider>
              </nz-col>
            </nz-row>
          </div>
          <div class="dir-y">
            <div class="row-x">
              <span>{{'truc_y' | translate}}</span>
              <nz-input-number
                [nzMin]="-30"
                [nzMax]="30"
                [ngStyle]="{ marginLeft: '16px', width: '40%' }"
                [(ngModel)]="config['box-shadow']['offset_y']"
                (ngModelChange)="onChangeShadow()"
                (nzOnAfterChange)="updateObject()"
                [disabled]="!config['box-shadow']['shadow_check']"
              ></nz-input-number>
            </div>
            <nz-row>
              <nz-col nzSpan="24">
                <nz-slider
                  [nzMin]="-30"
                  [nzMax]="30"
                  [(ngModel)]="config['box-shadow']['offset_y']"
                  (ngModelChange)="onChangeShadow()"
                  (nzOnAfterChange)="updateObject()"
                  [nzDisabled]="!config['box-shadow']['shadow_check']"
                ></nz-slider>
              </nz-col>
            </nz-row>
          </div>
          <div class="dir-b">
            <div class="row-b">
              <span style="line-height: 1.5">Làm mờ</span>
              <nz-input-number
                [nzMin]="-30"
                [nzMax]="30"
                [ngStyle]="{ width: '40%' }"
                [(ngModel)]="config['box-shadow']['blur_radius']"
                (ngModelChange)="onChangeShadow()"
                (nzOnAfterChange)="updateObject()"
                [disabled]="!config['box-shadow']['shadow_check']"
              ></nz-input-number>
            </div>
            <nz-row>
              <nz-col nzSpan="24">
                <nz-slider
                  [nzMin]="-30"
                  [nzMax]="30"
                  [(ngModel)]="config['box-shadow']['blur_radius']"
                  (ngModelChange)="onChangeShadow()"
                  (nzOnAfterChange)="updateObject()"
                  [nzDisabled]="!config['box-shadow']['shadow_check']"
                ></nz-slider>
              </nz-col>
            </nz-row>
          </div>
        </div>
        <div class="item-shadow">
          <p class="m-0 title w-50">{{'mau_bong' | translate}}</p>
          <input
            class="input-color w-50"
            type="button"
            [cpOKButton]="true" [(colorPicker)]="config['box-shadow']['shadow_color']"
            [style.background]="config['box-shadow']['shadow_color']"
            (colorPickerClose)="updateObject()"
            [cpWidth]="'230px'"
            [cpPositionRelativeToArrow]="true"
            [disabled]="!config['box-shadow']['shadow_check']"
          />

          <!-- <input type="color" class="input-shadow" [value]="config['box-shadow']['shadow_color']"
            [(ngModel)]="config['box-shadow']['shadow_color']" (ngModelChange)="onChangeShadow()"
            (blur)="updateObject()" [disabled]="!config['box-shadow']['shadow_check']" /> -->
        </div>
      </li>
      <!-- Cấu hình hình dạng viền -->
      <li
        nz-submenu
        nzTitle="{{'kieu_vien' | translate}}"
        [(nzOpen)]="openMap.menu2"
        (nzOpenChange)="openHandler('menu5')"
      >
        <div class="item-border">
          <p class="m-0 title-border">Kiểu viền</p>
          <div class="field-widget">
            <button
              nz-dropdown
              nzTrigger="click"
              [nzDropdownMenu]="menuBorder"
              nzPopoverTrigger="click"
            >
              <mat-icon>border_style</mat-icon>
            </button>
          </div>
          <!-- Menu các kiểu viền khác -->
          <nz-dropdown-menu #menuBorder="nzDropdownMenu">
            <ul nz-menu>
              <!-- Kiểu viền solid -->
              <li nz-menu-item>
                <button
                  (click)="
                    class['button']['border-style'] = 'solid'; updateClass()
                  "
                  nz-tooltip
                  nzTooltipTitle="Solid"
                  nzTooltipPlacement="left"
                  class="widget-button"
                  [ngClass]="{
                    active: class['button']['border-style'] == 'solid'
                  }"
                >
                  <div class="icon-field">
                    <svg
                      width="16px"
                      height="16px"
                      viewBox="0 0 15 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M1.25 7.5C1.25 7.22386 1.47386 7 1.75 7H13.25C13.5261 7 13.75 7.22386 13.75 7.5C13.75 7.77614 13.5261 8 13.25 8H1.75C1.47386 8 1.25 7.77614 1.25 7.5Z"
                        fill="#000000"
                      />
                    </svg>
                  </div>
                </button>
              </li>
              <!-- Kiểu viền double -->
              <li nz-menu-item>
                <button
                  (click)="
                    class['button']['border-style'] = 'double'; updateClass()
                  "
                  nz-tooltip
                  nzTooltipTitle="Double"
                  nzTooltipPlacement="left"
                  class="widget-button"
                  [ngClass]="{
                    active: class['button']['border-style'] == 'double'
                  }"
                >
                  <div class="icon-field">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-border-style"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M1 3.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-1zm0 4a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-1zm0 4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm8 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-4 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm8 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-4-4a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-1z"
                      />
                    </svg>
                  </div>
                </button>
              </li>
              <!-- Kiểu viền dashed -->
              <li nz-menu-item>
                <button
                  (click)="
                    class['button']['border-style'] = 'dashed'; updateClass()
                  "
                  nz-tooltip
                  nzTooltipTitle="Dashed"
                  nzTooltipPlacement="left"
                  class="widget-button"
                  [ngClass]="{
                    active: class['button']['border-style'] == 'dashed'
                  }"
                >
                  <div class="icon-field">
                    <svg
                      width="16px"
                      height="16px"
                      viewBox="0 0 15 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M0 7.5C0 7.22386 0.223858 7 0.5 7H3C3.27614 7 3.5 7.22386 3.5 7.5C3.5 7.77614 3.27614 8 3 8H0.5C0.223858 8 0 7.77614 0 7.5ZM5.75 7.5C5.75 7.22386 5.97386 7 6.25 7H8.75C9.02614 7 9.25 7.22386 9.25 7.5C9.25 7.77614 9.02614 8 8.75 8H6.25C5.97386 8 5.75 7.77614 5.75 7.5ZM12 7C11.7239 7 11.5 7.22386 11.5 7.5C11.5 7.77614 11.7239 8 12 8H14.5C14.7761 8 15 7.77614 15 7.5C15 7.22386 14.7761 7 14.5 7H12Z"
                        fill="#000000"
                      />
                    </svg>
                  </div>
                </button>
              </li>
              <!-- Kiểu viền dotted -->
              <li nz-menu-item>
                <button
                  (click)="
                    class['button']['border-style'] = 'dotted'; updateClass()
                  "
                  nz-tooltip
                  nzTooltipTitle="Dotted"
                  nzTooltipPlacement="left"
                  class="widget-button"
                  [ngClass]="{
                    active: class['button']['border-style'] == 'dotted'
                  }"
                >
                  <div class="icon-field">
                    <i class="bi bi-three-dots"></i>
                  </div>
                </button>
              </li>
            </ul>
          </nz-dropdown-menu>
        </div>
        <div class="item-border-size">
          <!-- Điều chỉnh kích thước viền trên -->
          <div class="row-border">
            <p class="m-0 title-border" style="line-height: 1.5">
              Kích thước viền trên
            </p>
            <nz-input-number
              [nzMin]="0"
              [nzMax]="50"
              style="min-width: 40%"
              [ngModel]="class['button']['border-top-width'] | vhnumber"
              (nzBlur)="updateClass()"
              (ngModelChange)="
                class['button']['border-top-width'] = $event + 'px'
              "
            ></nz-input-number>
          </div>
          <nz-row>
            <nz-col nzSpan="24">
              <nz-slider
                [nzMin]="0"
                [nzMax]="50"
                [ngModel]="class['button']['border-top-width'] | vhnumber"
                (nzOnAfterChange)="updateClass()"
                (ngModelChange)="
                  class['button']['border-top-width'] = $event + 'px'
                "
              ></nz-slider>
            </nz-col>
          </nz-row>
          <!-- Điều chỉnh kích thước viền dưới -->
          <div class="row-border">
            <p class="m-0 title-border" style="line-height: 1.5">
              Kích thước viền dưới
            </p>
            <nz-input-number
              [nzMin]="0"
              [nzMax]="50"
              style="min-width: 40%"
              [ngModel]="class['button']['border-bottom-width'] | vhnumber"
              (nzBlur)="updateClass()"
              (ngModelChange)="
                class['button']['border-bottom-width'] = $event + 'px'
              "
            ></nz-input-number>
          </div>
          <nz-row>
            <nz-col nzSpan="24">
              <nz-slider
                [nzMin]="0"
                [nzMax]="50"
                [ngModel]="class['button']['border-bottom-width'] | vhnumber"
                (nzOnAfterChange)="updateClass()"
                (ngModelChange)="
                  class['button']['border-bottom-width'] = $event + 'px'
                "
              ></nz-slider>
            </nz-col>
          </nz-row>
          <!-- Điều chỉnh kích thước viền trái -->
          <div class="row-border">
            <p class="m-0 title-border" style="line-height: 1.5">
              Kích thước viền trái
            </p>
            <nz-input-number
              [nzMin]="0"
              [nzMax]="50"
              style="min-width: 40%"
              [ngModel]="class['button']['border-left-width'] | vhnumber"
              (nzBlur)="updateClass()"
              (ngModelChange)="
                class['button']['border-left-width'] = $event + 'px'
              "
            ></nz-input-number>
          </div>
          <nz-row>
            <nz-col nzSpan="24">
              <nz-slider
                [nzMin]="0"
                [nzMax]="50"
                [ngModel]="class['button']['border-left-width'] | vhnumber"
                (nzOnAfterChange)="updateClass()"
                (ngModelChange)="
                  class['button']['border-left-width'] = $event + 'px'
                "
              ></nz-slider>
            </nz-col>
          </nz-row>
          <!-- Điều chỉnh kích thước viền phải -->
          <div class="row-border">
            <p class="m-0 title-border" style="line-height: 1.5">
              Kích thước viền phải
            </p>
            <nz-input-number
              [nzMin]="0"
              [nzMax]="50"
              style="min-width: 40%"
              [ngModel]="class['button']['border-right-width'] | vhnumber"
              (nzBlur)="updateClass()"
              (ngModelChange)="
                class['button']['border-right-width'] = $event + 'px'
              "
            ></nz-input-number>
          </div>
          <nz-row>
            <nz-col nzSpan="24">
              <nz-slider
                [nzMin]="0"
                [nzMax]="50"
                [ngModel]="class['button']['border-right-width'] | vhnumber"
                (nzOnAfterChange)="updateClass()"
                (ngModelChange)="
                  class['button']['border-right-width'] = $event + 'px'
                "
              ></nz-slider>
            </nz-col>
          </nz-row>
        </div>
        <!-- Lựa chọn màu viền -->
        <div class="item-border">
          <p class="m-0 title">{{'mau_vien' | translate}} </p>
          <div class="color-pick">
            <input
              id="head"
              class="input-color" type="button" 
              [cpOKButton]="true" [(colorPicker)]="class['button']['border-color']"
              [style.background]="class['button']['border-color']"
              (colorPickerClose)="updateObject()"
              [cpWidth]="'230px'"
              [cpPositionRelativeToArrow]="true"
            />
          </div>
        </div>
        <!-- Nút mở rộng -->
        <div class="item-border my-3" style="float: right">
          <p
            class="m-0 title-border my-2"
            (click)="openViewAll(styles_field[1])"
          >
            Mở rộng &#8594;
          </p>
        </div>
      </li>
      <!-- Cấu hình biểu tượng -->
      <li
        nz-submenu
        nzTitle="{{'bieu_tuong' | translate}}"
        [(nzOpen)]="openMap.menu6"
        (nzOpenChange)="openHandler('menu6')"
      >
        <div class="item-symbol">
          <p class="title" style="line-height: 1.5">{{'su_dung' | translate}}</p>
          <nz-switch
            [(ngModel)]="config['flex-direction'].icon_disable"
            (ngModelChange)="updateConfig()"
          ></nz-switch>
        </div>
        <div class="d-flex justify-content-between mx-1">
          <mat-icon>{{ config["flex-direction"].icon_name }}</mat-icon>
          <button
            nz-button
            nzType="default"
            (click)="openDialogChooseIcon()"
            style="border-radius: 5px"
            [disabled]="!config['flex-direction'].icon_disable"
          >
            Thay đổi
          </button>
        </div>
        <div class="font-size-symbol">
          <div class="slide-bar">
            <p class="m-0 title">{{'kich_thuoc' | translate}}</p>
            <nz-input-number
              [nzMin]="10"
              [nzMax]="50"
              style="width: 40%"
              [ngModel]="class['button__content--icon']['font-size'] | vhnumber"
              (nzBlur)="updateClass()"
              (ngModelChange)="
                class['button__content--icon']['font-size'] = $event + 'px'
              "
              [nzDisabled]="!config['flex-direction'].icon_disable"
            ></nz-input-number>
          </div>
          <div class="font-size">
            <nz-slider
              [nzMin]="10"
              [nzMax]="50"
              [ngModel]="class['button__content--icon']['font-size'] | vhnumber"
              (nzOnAfterChange)="updateClass()"
              (ngModelChange)="
                class['button__content--icon']['font-size'] = $event + 'px'
              "
              [nzDisabled]="!config['flex-direction'].icon_disable"
            ></nz-slider>
          </div>
          <div class="space-middle">
            <div class="slide-bar">
              <p class="m-0 title">Khoảng cách</p>
              <nz-input-number
                [ngModel]="class['button']['gap'] | vhnumber"
                (nzBlur)="updateClass()"
                style="width: 40%"
                (ngModelChange)="class['button']['gap'] = $event + 'px'"
                [nzDisabled]="!config['flex-direction'].icon_disable"
              ></nz-input-number>
            </div>
            <nz-slider
              [ngModel]="class['button']['gap'] | vhnumber"
              (nzOnAfterChange)="updateClass()"
              (ngModelChange)="class['button']['gap'] = $event + 'px'"
              [nzDisabled]="!config['flex-direction'].icon_disable"
            ></nz-slider>
          </div>
          <div class="space-middle">
            <div class="slide-bar">
              <p class="m-0 title w-50">{{ 'mau_sac' | translate }}</p>
              <input
                style="width: 50%"
                class="input-color"
                type="button"
                [cpOKButton]="true" [(colorPicker)]="class['button__content--icon'].color"
                [style.background]="class['button__content--icon'].color"
                (colorPickerClose)="updateObject()"
                [disabled]="!config['flex-direction'].icon_disable"
              />
            </div>
          </div>
        </div>
        <div class="position-symbol">
          <p class="title">Thay đổi vị trí</p>
          <div class="check-radio">
            <div class="form-check">
              <input
                class="form-check-input check-input"
                [value]="config['flex-direction'].flex_row"
                type="radio"
                name="flexRadio"
                id="flexRadio1"
                (change)="
                  this.class['button']['flex-direction'] =
                    config['flex-direction'].flex_row;
                  updateClass()
                "
                [checked]="
                  class['button']['flex-direction'] ==
                  config['flex-direction'].flex_row
                "
                [disabled]="!config['flex-direction'].icon_disable"
              />
              <span class="form-check-label" for="flexRadio1">
                Chữ trước biểu tượng sau
              </span>
            </div>
            <div class="form-check">
              <input
                class="form-check-input check-input"
                [value]="config['flex-direction'].flex_row_reverse"
                type="radio"
                name="flexRadio"
                id="flexRadio2"
                (change)="
                  this.class['button']['flex-direction'] =
                    config['flex-direction'].flex_row_reverse;
                  updateClass()
                "
                [checked]="
                  class['button']['flex-direction'] ==
                  config['flex-direction'].flex_row_reverse
                "
                [disabled]="!config['flex-direction'].icon_disable"
              />
              <span class="form-check-label" for="flexRadio2">
                Chữ sau biểu tượng trước
              </span>
            </div>
            <div class="form-check">
              <input
                class="form-check-input check-input"
                [value]="class['button'].flex_row_column_reverse"
                type="radio"
                name="flexRadio"
                id="flexRadio2"
                (change)="
                  this.class['button']['flex-direction'] =
                    config['flex-direction'].flex_row_column_reverse;
                  updateClass()
                "
                [checked]="
                  class['button']['flex-direction'] ==
                  config['flex-direction'].flex_row_column_reverse
                "
                [disabled]="!config['flex-direction'].icon_disable"
              />
              <span class="form-check-label" for="flexRadio2">
                Biểu tượng nằm trên chữ
              </span>
            </div>
            <div class="form-check">
              <input
                class="form-check-input check-input"
                [value]="config['flex-direction'].flex_row_column"
                type="radio"
                name="flexRadio"
                id="flexRadio2"
                (change)="
                  this.class['button']['flex-direction'] =
                    config['flex-direction'].flex_row_column;
                  updateClass()
                "
                [checked]="
                  class['button']['flex-direction'] ==
                  config['flex-direction'].flex_row_column
                "
                [disabled]="!config['flex-direction'].icon_disable"
              />
              <span class="form-check-label" for="flexRadio2">
                Biểu tượng nằm dưới chữ
              </span>
            </div>
          </div>
        </div>
      </li>
      <!-- Cấu hình hiệu ứng -->
      <li
        nz-submenu
        nzTitle="{{'hieu_ung' | translate}}"
        [(nzOpen)]="openMap.menu7"
        (nzOpenChange)="openHandler('menu7')"
      >
        <nz-select
          [(ngModel)]="staticdata[device + '_animation_type']"
          (ngModelChange)="changeTypeAnimation()"
        >
          <nz-option
            *ngIf="device == 'desktop'"
            nzValue="hover"
            nzLabel="Khi rê chuột"
          ></nz-option>
          <nz-option nzValue="keyframes" nzLabel="Tự động"></nz-option>
          <nz-option nzValue="visible" nzLabel="Khi xuất hiện"></nz-option>
        </nz-select>
        <div class="button-hover" nz-row>
          <div
            nz-col
            nzSpan="10"
            class="effect-button"
            *ngFor="let e of effect_hover_data?.data"
            (click)="chooseHover(e)"
            [ngClass]="{
              selected: e.id === config['animation-selected'].id ? true : false
            }"
          >
            <button
              [ngClass]="'animation-0'"
              class="m-0"
              (mouseover)="vhQueryAutoWeb.animationFromJSON($event, e)"
            >
              <span
                style="font-size: 13px; white-space: normal; z-index: 1000"
                >{{ e.name }}</span
              >
            </button>
          </div>
        </div>
      </li>
    </ul>
  </ng-container>
  <!-- Xem chi tiết cấu hình object -->
  <div class="view-more" *ngIf="isViewAll">
    <!-- Cấu hình chi tiết viền -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 2">
      <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
        [borderRadiusClass]="class['button']" [id_object]="objectChoosing._id">
      </app-borders-radius-config>
    </div>

    <!-- Cấu hình chi tiết hiệu ứng -->
    <div class="editor_effect-hover" *ngIf="currentViewAll.index == 3">
      <app-animations-config
        [staticdata]="staticdata"
        [id_object]="objectChoosing._id"
        [customize]="customize"
        [device]="device"
      ></app-animations-config>
    </div>
    <!-- Cấu hình chi tiết màu gradient  -->
    <div class="container-gradient" *ngIf="currentViewAll.index == 4">
      <div class="title-head">
        <p class="text-fill">Phối màu</p>
        <label
          nz-checkbox
          [(ngModel)]="config['background-color'].gradient_check"
          (ngModelChange)="updateBackgroundRgb()"
        ></label>
      </div>
      <div class="list-gradient">
        <button
          class="btn-gradient"
          *ngFor="
            let bgGradient of config['background-color']['gradient_arr'];
            let i = index
          "
          (click)="deleteGradient(i)"
          [ngStyle]="{ 'background-color': bgGradient }"
          [disabled]="!config['background-color'].gradient_check"
        >
          <i class="delete-icon bi bi-x-circle"></i>
        </button>
      </div>
      <p class="title-head">{{ 'them_mau' | translate }}</p>
      <div class="container_add-gradient">
        <input
          class="input-color"
          [cpOKButton]="true" [(colorPicker)]="class['button']['background-color']"
          type="button"
          [disabled]="!config['background-color'].gradient_check"
          [style.background]="class['button']['background-color']"
          (colorPickerClose)="addGradient($event)"
        />
      </div>
      <p class="title-head">{{ 'huong_phoi_mau' | translate }}</p>
      <button
        class="gradient-direction"
        *ngFor="let type of typeGradient"
        nz-tooltip
        [nzTooltipTitle]="type.name"
        (click)="chooseOption(type, $event)"
        [disabled]="!config['background-color'].gradient_check"
        [style.background]="
          'linear-gradient(' + type.deg + ', #2764EB, #EFE810)'
        "
      ></button>
    </div>
  </div>
</div>
